import { notification } from "@/utils/utils"
import { i18n } from "@/plugins/i18n"

export async function connectionRemoved(value, selected_nodes, dispatch) {
	///Funnzione verificata
	/*cose grafiche */
	const nodes = Array.from(document.querySelectorAll("[id^=node]"))
	// toglie il colore alle bubble di input e output
	const srcNode = nodes.filter(x => x.id.split("-")[1] === String(value.output_id))[0].childNodes[2]
	const dstNode = nodes.filter(x => x.id.split("-")[1] === String(value.input_id))[0].childNodes[0]
	if (srcNode.querySelector(`.output.${value.output_class}`)) {
		srcNode.querySelector(`.output.${value.output_class}`).style.backgroundColor = "#fff"
	}
	if (dstNode.querySelector(`.input.${value.input_class}`)) {
		dstNode.querySelector(`.input.${value.input_class}`).style.backgroundColor = "#fff"
	}
	// path rimanenti
	const path = Array.from(document.getElementsByTagName("svg"))
	for (let i = 0; i < path.length; i++) {
		let pathClasses = Array.from(path[i].classList)
		if (pathClasses[4] === value.input_class && pathClasses[1].split("-")[1] === value.input_id) {
			const dstNode = nodes.filter(x => x.id === `node-${value.input_id}`)[0].childNodes[0]
			dstNode.childNodes[value.input_class.split("_")[1] - 1].style.backgroundColor =
				path[i].childNodes[0].style.stroke
		}
	}
	/*fine cose grafiche*/
	//nodo uotput update
	var node = selected_nodes.find(i => i.id == value.output_id)
	if (node) {
		var ind = node.children.findIndex(i => i == value.input_id)
		node.children.splice(ind, 1)
		dispatch("editNodeDependecies", {
			node_id: value.output_id,
			parent: node.parent,
			children: node.children
		})
		if (node.question.value !== "" && node.question.map !== []) {
			var tmp_node_ind = node.question.map.findIndex(i => i.ref == value.input_id)
			if (node.question.map[tmp_node_ind]) {
				node.question.map[tmp_node_ind].ref = undefined
				dispatch("editNodeDependecies", { node_id: value.output_id, question: node.question })
			}
		}
	}
	//nodo input update
	var node2 = selected_nodes.find(i => i.id == value.input_id)
	if (node2) {
		var ind2 = node2.parent.findIndex(i => i == value.output_id)
		node2.parent.splice(ind2, 1)
		dispatch("editNodeDependecies", { node_id: value.input_id, parent: node2.parent, children: node2.children })
		if (node2.answer !== "") {
			node2.answer = ""
			dispatch("editNodeDependecies", { node_id: value.input_id, answer: node2.answer })
		}
	}
}

export async function connectionCreated(value, selected_nodes, editor, dispatch) {
	if ((await editor.getNodeFromId(value.input_id)).inputs[value.input_class].connections.length > 1) {
		editor.removeSingleConnection(value.output_id, value.input_id, value.output_class, value.input_class)
		notification("warning", i18n.t("warning"), i18n.t("ball-error"))
		return true
	}

	//nodo uotput update
	var node = selected_nodes.find(i => i.id == value.output_id)
	if (node.children.indexOf(value.input_id + "") === -1) {
		node.children.push(value.input_id + "")
	}
	await dispatch("editNodeDependecies", {
		node_id: value.output_id,
		parent: node.parent,
		children: node.children
	})
	/* check if question */
	//nodo input update
	var node2 = selected_nodes.find(i => i.id == value.input_id)
	if (node2.parent.indexOf(value.output_id + "") === -1) {
		node2.parent.push(value.output_id + "")
	}
	await dispatch("editNodeDependecies", {
		node_id: value.input_id,
		parent: node2.parent,
		children: node2.children
	})
	if (node.question.value && node.question.map !== []) {
		if (
			node.question.map[value.output_class.split("_")[1] - 1] &&
			node.question.map[value.output_class.split("_")[1] - 1].ref == undefined
		) {
			node.question.map[value.output_class.split("_")[1] - 1].ref = Number(value.input_id)
		}
		if (!node2.answer) {
			node2.answer = node.question.map[value.output_class.split("_")[1] - 1].value
			dispatch("editNodeDependecies", { node_id: value.input_id, answer: node2.answer })
		}
	}
	const color = randomColor()
	var to_node = await editor.getNodeFromId(value.input_id)
	var from_node = await editor.getNodeFromId(value.output_id)
	// if (from_node.data.type == 'action') {
	//     var h = from_node.data.content[value.output_class];
	//     var newprops = {
	//         ...to_node.data,
	//         title: h,
	//         text: h
	//     };
	//     editor.updateNodeDataFromId(value.input_id, newprops)
	// }
	// colore alle bubble di input e output + path
	const nodes = Array.from(document.querySelectorAll("[id^=node]"))
	const srcNode = nodes.filter(x => x.id.split("-")[1] === String(from_node.id))[0]
	const dstNode = nodes.filter(x => x.id.split("-")[1] === String(to_node.id))[0]
	const srcBubble = srcNode.childNodes[2]
	const dstBubble = dstNode.childNodes[0]
	srcBubble.querySelector(`.output.output_${value.output_class.split("_")[1]}`).style.backgroundColor = color
	dstBubble.querySelector(`.input.input_${value.input_class.split("_")[1]}`).style.backgroundColor = color
	const path = Array.from(document.getElementsByTagName("svg"))
	for (let i = 0; i < path.length; i++) {
		let outputBubble = srcBubble
			.querySelector(`.output.output_${value.output_class.split("_")[1]}`)
			.className.split(" ")[1]
		let inputBubble = dstBubble
			.querySelector(`.input.input_${value.input_class.split("_")[1]}`)
			.className.split(" ")[1]
		let classes = `.node_in_${dstNode.id}.node_out_${srcNode.id}.${outputBubble}.${inputBubble}`
		if (path[i].matches(classes)) path[i].childNodes[0].style.stroke = color
	}
}

export function randomColor() {
	return `rgb(${Math.round(Math.random() * 255)},${Math.round(Math.random() * 255)},${Math.round(
		Math.random() * 255
	)})`
}
